import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const NavFlyoutTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  zIndex: 1000000,
  [`& .${tooltipClasses.tooltip}`]: {
    padding: 0,
    maxWidth: 'none',
    backgroundColor: 'transparent',
    color: 'inherit',
    borderRadius: 0,
  },
});

export default NavFlyoutTooltip;
